const readableFileType = (fileType: string): string => {
  switch (fileType) {
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'application/vnd.ms-excel':
      return 'xls'
    case 'text/csv':
      return 'csv'
    default:
      return fileType
  }
}

export const readableFileTypesWithCommaAndY = (fileType: string | string[]): string => {
  const fileTypes = Array.isArray(fileType) ? fileType : [fileType]
  const mapped = fileTypes.map(readableFileType)

  if (mapped.length <= 1) return mapped.join('')
  if (mapped.length === 2) return mapped.join(' y ')

  // Para 3 o más elementos
  return mapped.slice(0, -1).join(', ') + ' y ' + mapped[mapped.length - 1]
}
